import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import FusionCharts from "fusioncharts";
import FusionMaps from "fusioncharts/fusioncharts.maps";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import USA from "fusionmaps/maps/fusioncharts.usa";
import Alabama from "fusionmaps/maps/fusioncharts.alabama";
import AlaskaCustomMapCurrent from "./CustomMaps/AlaskaMap_2022-present";
import AlaskaMap_20162022 from "./CustomMaps/AlaskaMap_2016-2022";
import AlaskaMap_20142015 from "./CustomMaps/AlaskaMap_2014-2015";
import AlaskaMap_19942013 from "./CustomMaps/AlaskaMap_1994-2013";
import AmericanSamoaMap from "./CustomMaps/AmericaSamoa";
import Arizona from "fusionmaps/maps/fusioncharts.arizona";
import Arkansas from "fusionmaps/maps/fusioncharts.arkansas";
import California from "fusionmaps/maps/fusioncharts.california";
import Colorado from "fusionmaps/maps/fusioncharts.colorado";
import ConnecticutCustomMap from "./CustomMaps/ConnecticutMap";
import Connecticut from "fusionmaps/maps/fusioncharts.connecticut";
import DistrictOfColumbiaModified from "./CustomMaps/DistrictOfColumnbia";
import Delaware from "fusionmaps/maps/fusioncharts.delaware";
import Florida from "fusionmaps/maps/fusioncharts.florida";
import Georgia from "fusionmaps/maps/fusioncharts.georgia";
import Hawaii from "fusionmaps/maps/fusioncharts.hawaii";
import Idaho from "fusionmaps/maps/fusioncharts.idaho";
import Illinois from "fusionmaps/maps/fusioncharts.illinois";
import Indiana from "fusionmaps/maps/fusioncharts.indiana";
import Iowa from "fusionmaps/maps/fusioncharts.iowa";
import Kansas from "fusionmaps/maps/fusioncharts.kansas";
import Kentucky from "fusionmaps/maps/fusioncharts.kentucky";
import Louisiana from "fusionmaps/maps/fusioncharts.louisiana";
import Maine from "fusionmaps/maps/fusioncharts.maine";
import Maryland from "fusionmaps/maps/fusioncharts.maryland";
import Massachusetts from "fusionmaps/maps/fusioncharts.massachusetts";
import Michigan from "fusionmaps/maps/fusioncharts.michigan";
import Minnesota from "fusionmaps/maps/fusioncharts.minnesota";
import Mississippi from "fusionmaps/maps/fusioncharts.mississippi";
import Missouri from "fusionmaps/maps/fusioncharts.missouri";
import Montana from "fusionmaps/maps/fusioncharts.montana";
import Nebraska from "fusionmaps/maps/fusioncharts.nebraska";
import Nevada from "fusionmaps/maps/fusioncharts.nevada";
import NewHampshire from "fusionmaps/maps/fusioncharts.newhampshire";
import NewJersey from "fusionmaps/maps/fusioncharts.newjersey";
import NewMexico from "fusionmaps/maps/fusioncharts.newmexico";
import NewYork from "fusionmaps/maps/fusioncharts.newyork";
import NorthCarolina from "fusionmaps/maps/fusioncharts.northcarolina";
import NorthDakota from "fusionmaps/maps/fusioncharts.northdakota";
import NorthernMarianaIslands from "./CustomMaps/NorthernMarianaIslands";
import Ohio from "fusionmaps/maps/fusioncharts.ohio";
import Oklahoma from "fusionmaps/maps/fusioncharts.oklahoma";
import Oregon from "fusionmaps/maps/fusioncharts.oregon";
import Pennsylvania from "fusionmaps/maps/fusioncharts.pennsylvania";
import RhodeIsland from "fusionmaps/maps/fusioncharts.rhodeisland";
import SouthCarolina from "fusionmaps/maps/fusioncharts.southcarolina";
import SouthDakota from "fusionmaps/maps/fusioncharts.southdakota";
import Tennessee from "fusionmaps/maps/fusioncharts.tennessee";
import Texas from "fusionmaps/maps/fusioncharts.texas";
import Utah from "fusionmaps/maps/fusioncharts.utah";
import Vermont from "fusionmaps/maps/fusioncharts.vermont";
import VirginiaMap19942013 from "./CustomMaps/VirginiaMap_1994-2013";
import VirginiaMap2014present from "./CustomMaps/VirginiaMap_2014-present";
import Washington from "fusionmaps/maps/fusioncharts.washington";
import WestVirginia from "fusionmaps/maps/fusioncharts.westvirginia";
import Wisconsin from "fusionmaps/maps/fusioncharts.wisconsin";
import Wyoming from "fusionmaps/maps/fusioncharts.wyoming";
import React from "react";
import ReactFC from "react-fusioncharts";
import { fetchData } from "../../common/services/ApiClient";
import { ApiBaseUrl } from "../../config";
import {
  KeyNumberValue,
  KeyValue,
  Query,
  SearchPillData,
  TableHeader,
} from "../../interfaces";
import HeatBoxIcon from "./HeatBoxIcon";
import { licenseKey } from "./license";
import { territoryMapping, getMapType } from "./utilities";
import ShowHideButton from "../ShowHideButton";
import SearchPills from "../../containers/SearchPills";
import SODStateList from "../SOD/BranchOfficeDeposits/SODStateList";
import MultiHeaderTable from "../MultiHeaderTable/MultiHeaderTable";
import Guamcongressional from "fusionmaps/maps/fusioncharts.guamcongressional";
import Micronesia from "fusionmaps/maps/fusioncharts.micronesia";
import Marshallisland from "fusionmaps/maps/fusioncharts.marshallisland";
import Palau from "fusionmaps/maps/fusioncharts.palau";
import Puertorico from "fusionmaps/maps/fusioncharts.puertorico";
import USVirginIsland from "fusionmaps/maps/fusioncharts.usvirginisland";
import ResultsViewToggle from "./ResultsViewToggle";
import { reduceObj } from "../../common/services/Utilities";
import TableChartIcon from "@mui/icons-material/TableChart";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import { selectedStatesAlpha } from "../../refdata/FilterOptions";
const PREFIX = "USAMap";

const classes = {
  cardDisplay: `${PREFIX}-cardDisplay`,
  statesHeading: `${PREFIX}-statesHeading`,
  territory: `${PREFIX}-territory`,
  footer: `${PREFIX}-footer`,
};

const Root = styled("div")<{
  $isCountyView: boolean;
  dontShowCountyData: boolean;
  $modalHeatMap: boolean | undefined;
  providedAppState: Query | undefined;
}>(({ theme, $isCountyView, dontShowCountyData, $modalHeatMap }) => ({
  [`& .${classes.cardDisplay}`]: {
    "border": `1px solid ${theme.palette.primary.main}`,
    "borderRadius": 8,
    "color": theme.palette.primary.main,
    "& .MuiTypography-body1": {
      fontSize: ".875rem",
      lineHeight: "1rem",
      paddingBottom: ".5rem",
    },
    "& .MuiCardContent-root": {
      padding: "1rem .5rem .5rem .5rem",
    },
  },

  [`& .${classes.footer}`]: {
    color: theme.palette.primary.main,
    lineHeight: "24px",
    fontSize: "14px",
    fontWeight: 400,
    textAlign: "left",
  },

  [`& .${classes.statesHeading}`]: {
    position: "relative",
    color: theme.palette.primary.main,
    fontSize: "1rem",
    fontWeight: "bolder",
    paddingLeft: 0,
    textAlign: "left",
    paddingBottom: 7,
  },

  [`& .${classes.territory}`]: {
    "& .MuiTypography-body2": {
      fontSize: ".875rem",
      whiteSpace: "nowrap",
      paddingTop: 2,
      fontWeight: 400,
      paddingBottom: 0,
      cursor: $isCountyView || $modalHeatMap ? "default" : "pointer",
    },
  },
  "& .fusioncharts-container svg g path": {
    cursor: $modalHeatMap
      ? "default"
      : !dontShowCountyData
        ? "pointer"
        : "default",
  },

  "& .fusioncharts-container svg [class^='raphael-group-'] rect": {
    cursor: $isCountyView || $modalHeatMap ? "default" : "pointer",
    ["cursor" as any]: `${$isCountyView || $modalHeatMap ? "default" : "pointer"} !important`,
  },
  // targets and removes the watermark
  "& .fusioncharts-container svg g[cursor='pointer'][fill='#b1b2b7']": {
    display: "none",
  },
}));

interface Props {
  appState: Query;
  locationsOnly?: boolean;
  locationsData?: KeyValue[];
  updateFilter: (field: string, value: string | string[]) => void;
  initialMode?: "map" | "table";
  modalHeatMap?: boolean;
  depositAppState?: Query;
  providedAppState?: Query;
  reportType?: any;
  cert?: any;
}

(FusionCharts as any).options["license"]({
  key: licenseKey,
  creditLabel: false,
});

ReactFC.fcRoot(
  FusionCharts,
  FusionMaps,
  USA,
  FusionTheme,
  Alabama,
  AlaskaMap_19942013,
  AlaskaMap_20142015,
  AlaskaMap_20162022,
  AlaskaCustomMapCurrent,
  AmericanSamoaMap,
  Arizona,
  Arkansas,
  California,
  Colorado,
  Connecticut,
  ConnecticutCustomMap,
  DistrictOfColumbiaModified,
  Delaware,
  Florida,
  Georgia,
  Guamcongressional,
  Hawaii,
  Idaho,
  Illinois,
  Indiana,
  Iowa,
  Kansas,
  Kentucky,
  Louisiana,
  Maine,
  Marshallisland,
  Maryland,
  Massachusetts,
  Michigan,
  Micronesia,
  Minnesota,
  Mississippi,
  Missouri,
  Montana,
  Nebraska,
  Nevada,
  NewHampshire,
  NewJersey,
  NewMexico,
  NewYork,
  NorthCarolina,
  NorthDakota,
  NorthernMarianaIslands,
  Ohio,
  Oklahoma,
  Oregon,
  Palau,
  Pennsylvania,
  Puertorico,
  RhodeIsland,
  SouthCarolina,
  SouthDakota,
  Tennessee,
  Texas,
  USVirginIsland,
  Utah,
  Vermont,
  VirginiaMap19942013,
  VirginiaMap2014present,
  Washington,
  WestVirginia,
  Wisconsin,
  Wyoming,
);

export const handleMouseOver = (
  state: string,
  stateAbbr: string,
  stateElement: KeyValue,
  summaryOfDepositsElement: KeyValue,
  summaryOfDepositsByState: KeyValue,
  institutionsElement: KeyValue,
  countOfInstitutionsByState: KeyValue,
  branchOfficesElement: KeyValue,
  countOfBranchOfficesByState: KeyValue,
) => {
  if (stateElement && stateElement.current) {
    stateElement.current.innerText = state;
  }
  if (
    summaryOfDepositsElement &&
    summaryOfDepositsElement.current &&
    stateAbbr
  ) {
    summaryOfDepositsElement.current.innerText = summaryOfDepositsByState[
      stateAbbr
    ]
      ? `$${summaryOfDepositsByState[stateAbbr].toLocaleString()}`
      : "$0";
  }
  if (institutionsElement && institutionsElement.current && stateAbbr) {
    institutionsElement.current.innerText = countOfInstitutionsByState[
      stateAbbr
    ]
      ? `${countOfInstitutionsByState[stateAbbr].toLocaleString()}`
      : "0";
  }
  if (branchOfficesElement && branchOfficesElement.current && stateAbbr) {
    branchOfficesElement.current.innerText = countOfBranchOfficesByState[
      stateAbbr
    ]
      ? `${countOfBranchOfficesByState[stateAbbr].toLocaleString()}`
      : "0";
  }
  return {
    state: stateElement,
    summary: summaryOfDepositsElement,
    institutions: institutionsElement,
    branches: branchOfficesElement,
  };
};

export const handleMouseOut = (
  stateElement: KeyValue,
  summaryOfDepositsElement: KeyValue,
  totalSummaryOfDeposits: number,
  institutionsElement: KeyValue,
  totalInstitutions: number,
  branchOfficesElement: KeyValue,
  totalBranchOffices: number,
) => {
  if (stateElement && stateElement.current) {
    stateElement.current.innerText = "All States and Territories";
  }
  if (summaryOfDepositsElement && summaryOfDepositsElement.current) {
    summaryOfDepositsElement.current.innerText = `$${totalSummaryOfDeposits.toLocaleString()}`;
  }
  if (institutionsElement && institutionsElement.current) {
    institutionsElement.current.innerText = `${totalInstitutions.toLocaleString()}`;
  }
  if (branchOfficesElement && branchOfficesElement.current) {
    branchOfficesElement.current.innerText = `${totalBranchOffices.toLocaleString()}`;
  }

  return {
    state: stateElement,
    summary: summaryOfDepositsElement,
    institutions: institutionsElement,
    branches: branchOfficesElement,
  };
};

export default function USAMap({
  appState,
  locationsOnly,
  locationsData,
  updateFilter,
  initialMode,
  modalHeatMap,
  depositAppState,
  providedAppState,
  reportType,
  cert,
}: Props) {
  const [countyNameByCodeLookup, setCountyNameByCodeLookup] = React.useState<
    Record<string, string>
  >({});
  const idFilter =
    modalHeatMap && depositAppState?.filters.cert
      ? ` AND CERT:${depositAppState?.filters.cert}`
      : cert
        ? ` AND CERT:${cert}`
        : modalHeatMap && depositAppState?.filters?.bhcRSSD
          ? ` AND RSSDHCR:${depositAppState?.filters.bhcRSSD}`
          : "";
  const [prevIdFilter, setPrevIdFilter] = React.useState(idFilter);
  const countyFilter =
    modalHeatMap && depositAppState?.filters?.county
      ? ` AND CNTYNAMB:"${depositAppState?.filters.county}"`
      : "";
  const msaFilter =
    modalHeatMap && depositAppState?.filters?.msa
      ? ` AND MSANAMB:"${depositAppState?.filters.msa}"`
      : "";
  const summaryTablesSearchPills: SearchPillData[] = [
    {
      label: "Reporting Period",
      value: `06/30/${appState.filters.lastYear}`,
      search: false,
      static: true,
      formKey: "lastYear",
    },
    {
      label: "State",
      value: `${appState.filters.stalpbr}`,
      search: false,
      static: false,
      formKey: "stalpbr",
    },
    {
      label: "County",
      value: `${appState.filters.county}`,
      search: false,
      static: false,
      formKey: "county",
    },
  ];

  const stateElement = React.useRef<HTMLInputElement>(
    document.createElement("state") as HTMLInputElement,
  );
  const institutionsElement = React.useRef<HTMLInputElement>(null);
  const branchOfficesElement = React.useRef<HTMLInputElement>(null);
  const [previousYear, setPreviousYear] = React.useState(1994);
  const summaryOfDepositsElement = React.useRef<HTMLInputElement>(null);
  const [mapData, setMapData] = React.useState<KeyValue[]>([]);

  const [summaryOfDepositsByState, setSummaryOfDepositsByState] =
    React.useState<KeyValue>({});
  const [summaryOfDepositsByCounty, setSummaryOfDepositsByCounty] =
    React.useState<KeyValue>({});
  const [totalInstitutions, setTotalInstitutions] = React.useState(0);
  const [totalBranchOffices, setTotalBranchOffices] = React.useState(0);
  const [totalSummaryOfDeposits, setTotalSummaryOfDeposits] = React.useState(0);
  const initialCountBy: KeyValue = {};
  const [countOfInstitutionsByState, setCountOfInstitutionsByState] =
    React.useState(initialCountBy);
  const [countOfBranchOfficesByState, setCountOfBranchOfficesByState] =
    React.useState(initialCountBy);

  const [legendRangeMinValue, setLegendRangeMinValue] = React.useState(0);
  const [legendRangeMaxValue, setLegendRangeMaxValue] =
    React.useState(38000000000000);
  const [countyMidMax, setCountyMidMax] = React.useState({
    low: 0,
    mid: 10000000,
    max: 20000000,
  });
  const [stateMidMax, setStateMidMax] = React.useState({
    low: 0,
    mid: 100000000,
    max: 250000000,
  });
  const [displayBranchOffices, setDisplayBranchOffices] = React.useState("0");

  const searchPills = (
    <div>
      <ShowHideButton
        title={`${displayBranchOffices} Branch Offices`}
        body={<SearchPills dataArray={summaryTablesSearchPills} />}
      />
    </div>
  );

  const handleRangeUpdated = (eventObj: KeyValue) => {
    setLegendRangeMinValue(eventObj.data.minValue);
    setLegendRangeMaxValue(eventObj.data.maxValue);
  };

  const footerMP = (
    <Typography className={classes.footer}>
      <br />
      **AKA Commonwealth of the Northern Mariana Islands
    </Typography>
  );
  const usStatesAndTerritories = [
    { abbr: "AS", label: "American Samoa" },
    {
      abbr: "FM",
      label: "Federated States of Micronesia",
      altLabel: "F.S. of Micronesia",
    },
    { abbr: "DC", label: "District of Columbia" },
    { abbr: "DE", label: "Delaware" },
    { abbr: "GU", label: "Guam" },
    { abbr: "MH", label: "Marshall Islands" },
    { abbr: "MP", label: "Northern Mariana Islands" },
    { abbr: "PW", label: "Palau" },
    { abbr: "PR", label: "Puerto Rico" },
    { abbr: "RI", label: "Rhode Island" },
    { abbr: "VI", label: "US Virgin Islands" },
  ];

  const [selectedStateAbbr, setSelectedStateAbbr] = React.useState<
    string | null
  >(appState.filters.stalpbr || null);
  const statesWithNoCounties = new Set(["MP"]);
  const dontShowCountyData: boolean =
    selectedStateAbbr && statesWithNoCounties.has(selectedStateAbbr)
      ? true
      : false;

  const [selectedState, setSelectedState] = React.useState<string | null>(
    appState.filters.stalpbr
      ? (usStatesAndTerritories.find((t) => t.abbr === appState.filters.stalpbr)
          ?.label ?? appState.filters.stalpbr)
      : null,
  );
  const [mapType, setMapType] = React.useState<string>(
    appState.filters.stalpbr &&
      getMapType(appState.filters.stalpbr, appState.filters.lastYear)
      ? getMapType(appState.filters.stalpbr, appState.filters.lastYear)
      : "maps/usa",
  );
  const [mode, setMode] = React.useState<string>(
    initialMode ?? (appState.filters.stalpbr ? "table" : "map"),
  );

  const [countyInstitutionsById, setCountyInstitutionsById] = React.useState<
    Record<string, number>
  >({});
  const [countyBranchesById, setCountyBranchesById] = React.useState<
    Record<string, number>
  >({});
  const isBHC = appState.ui.institutionType === "bhcs";
  const [openClose, setOpenClose] = React.useState("");
  const [openCloseHeader, setOpenCloseHeader] = React.useState<KeyValue>({});
  const [countyMapData, setCountyMapData] = React.useState<KeyValue[]>([]);

  const [chartId, setChartId] = React.useState(`usa-map-${Date.now()}`);
  const isCountyView = Boolean(appState.filters.stalpbr !== "");

  const handleCountyMouseOver = (countyLabel: string, countyId: string) => {
    if (dontShowCountyData) return;
    const normalizedId = countyId.split(".").slice(-2).join(".");
    if (stateElement?.current)
      stateElement.current.innerText =
        countyNameByCodeLookup[countyId] ?? countyLabel;
    if (summaryOfDepositsElement?.current) {
      const deposits = summaryOfDepositsByCounty[countyId] ?? 0;
      summaryOfDepositsElement.current.innerText = `$${deposits.toLocaleString()}`;
    }
    if (institutionsElement?.current) {
      const inst = countyInstitutionsById[normalizedId] ?? 0;
      institutionsElement.current.innerText = inst.toLocaleString();
    }
    if (branchOfficesElement?.current) {
      const branches = countyBranchesById[normalizedId] ?? 0;
      branchOfficesElement.current.innerText = branches.toLocaleString();
    }
  };

  const handleCountyMouseOut = () => {
    const abbr = selectedStateAbbr || "";
    const stateName = selectedStatesAlpha.filter((c) => c.value === abbr)[0]
      ?.label;
    if (stateElement?.current) {
      stateElement.current.innerText =
        stateName || selectedState || abbr || "State";
    }
    if (summaryOfDepositsElement?.current) {
      const dep = summaryOfDepositsByState?.[abbr] ?? 0;
      summaryOfDepositsElement.current.innerText = `$${dep.toLocaleString()}`;
    }
    if (institutionsElement?.current) {
      const inst = countOfInstitutionsByState?.[abbr] ?? 0;
      institutionsElement.current.innerText = inst.toLocaleString();
    }
    if (branchOfficesElement?.current) {
      const branches = countOfBranchOfficesByState?.[abbr] ?? 0;
      branchOfficesElement.current.innerText = branches.toLocaleString();
    }
  };

  React.useEffect(() => {
    if (!selectedStateAbbr || !appState.filters.lastYear || dontShowCountyData)
      return;
    let isMounted = true;
    const year = appState.filters.lastYear;
    const abbr = selectedStateAbbr.toUpperCase();
    // normalizes county names for virgin islands as they differ by years
    const normalizeVI = (name: string, abbr: string) =>
      abbr === "VI" ? name.replace(/\bSt\.\s+/i, "Saint ") : name;
    const depositsUrl =
      `${ApiBaseUrl()}/sod?agg_by=CNTYNAMB&agg_sum_fields=DEPSUMBR` +
      `&filters=YEAR:${year}%20AND%20STALPBR:"${abbr}"${idFilter}&agg_limit=500`;

    const instAndBranchesUrl =
      `${ApiBaseUrl()}/sod?agg_by=CNTYNAMB` +
      `&filters=YEAR:${year}%20AND%20STALPBR:"${abbr}"${idFilter}&get_unique=CERT&agg_limit=500`;

    const CNTYNUMB = `${ApiBaseUrl()}/sod?filters=STALPBR:"${abbr}"%20AND%20YEAR:${appState.filters.lastYear}${idFilter}&get_unique=CNTYNUMB&fields=CNTYNUMB,CNTYNAMB&limit=500`;

    (async () => {
      try {
        const [depResp, ibResp, countyCodes] = await Promise.all([
          fetchData(depositsUrl),
          fetchData(instAndBranchesUrl),
          fetchData(CNTYNUMB),
        ]);
        let countyNameToId = countyCodes.data.reduce(
          (acc: any, county: any) => {
            acc[county.CNTYNAMB] =
              abbr !== "PR"
                ? String(county.CNTYNUMB).padStart(3, "0")
                : String(county.CNTYNUMB).padStart(2, "0");
            return acc;
          },
          {} as Record<string, string>,
        );

        if (Object.keys(territoryMapping).includes(abbr)) {
          countyNameToId = territoryMapping[abbr];

          const activeCountyNames = new Set([
            ...(depResp.data ?? []).map((r: any) =>
              normalizeVI(r.CNTYNAMB, abbr),
            ),
            ...(ibResp.data ?? []).map((r: any) =>
              normalizeVI(r.CNTYNAMB, abbr),
            ),
          ]);

          countyNameToId = Object.fromEntries(
            Object.entries(countyNameToId).filter(([name]) =>
              activeCountyNames.has(normalizeVI(name, abbr)),
            ),
          );
        }
        const depositsById: Record<string, number> = {};
        const depositObj = reduceObj(
          depResp.data.map((data: KeyValue) => {
            return {
              key: countyNameToId[normalizeVI(data.CNTYNAMB, abbr)] || "",
              value: data?.sum_DEPSUMBR || 0,
            };
          }),
        );
        setSummaryOfDepositsByCounty(depositObj);

        for (const row of depResp.data ?? []) {
          const countyName = normalizeVI(row.CNTYNAMB, abbr);
          const countyId = countyNameToId[countyName];

          if (!countyId) continue;
          const normalizedId = countyId.split(".").slice(-2).join(".");

          depositsById[normalizedId] = (row?.sum_DEPSUMBR ?? 0) * 1000;
        }
        const institutionsById: Record<string, number> = {};
        const branchesById: Record<string, number> = {};

        for (const row of ibResp.data ?? []) {
          const countyName = normalizeVI(row.CNTYNAMB, abbr);
          const countyId = countyNameToId[countyName];
          if (!countyId) continue;
          const normalizedId = countyId.split(".").slice(-2).join(".");
          institutionsById[normalizedId] = row.unique_count ?? 0;
          branchesById[normalizedId] = row.count ?? 0;
        }

        const normalizedToDisplay: Record<string, string> = {};
        if (countyNameToId) {
          for (const countyName of Object.keys(countyNameToId)) {
            normalizedToDisplay[countyName] = countyName;
          }
        }
        const countyMapping = Object.entries(countyNameToId);
        const mapData: KeyValue[] = countyMapping.map(
          ([normalizedName, countyId]: any, index) => {
            const normalizedId = countyId.split(".").slice(-2).join(".");
            return {
              id: countyId,
              value: depositsById[normalizedId] ?? 0,
              ...(normalizedName && { toolText: `<b>${normalizedName}</b>` }),
            };
          },
        );
        if (!isMounted) return;
        const sortedDeposits = Object.values(depositsById).sort(
          (a, b) => a - b,
        );
        const highestDeposit = sortedDeposits[sortedDeposits.length - 1];
        const lowestDeposit = sortedDeposits.find((val) => val > 0) || 0;

        setCountyMidMax({
          low: lowestDeposit,
          mid:
            highestDeposit === lowestDeposit
              ? highestDeposit / 2
              : (highestDeposit + lowestDeposit) / 2,
          max: highestDeposit,
        });
        setCountyInstitutionsById(institutionsById);
        setCountyBranchesById(branchesById);
        setCountyMapData(mapData);
        const countyName = Object.fromEntries(
          countyCodes.data
            .map((county: any) => {
              const normalizedName = normalizeVI(county.CNTYNAMB, abbr);
              const id = countyNameToId[normalizedName];
              return [id, county.CNTYNAMB];
            })
            .filter(([id]: any) => Boolean(id)),
        );
        setCountyNameByCodeLookup(countyName);
      } catch (e) {
        console.error(e);
      } finally {
        isMounted = false;
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [
    selectedStateAbbr,
    appState.filters.lastYear,
    dontShowCountyData,
    idFilter,
  ]);

  React.useEffect(() => {
    //gets total count of summary of deposits (total and by state)
    if (
      appState.filters.lastYear &&
      (((Object.keys(summaryOfDepositsByState).length === 0 ||
        Object.keys(totalSummaryOfDeposits).length === 0) &&
        appState.filters.lastYear !== previousYear) ||
        idFilter !== prevIdFilter)
    ) {
      let isMounted = true;
      const sumDepositsDataByState: KeyNumberValue = {};
      setPrevIdFilter(idFilter);
      (async () => {
        await fetchData(
          `${ApiBaseUrl()}/sod?agg_by=STALPBR&agg_sum_fields=DEPSUMBR&filters=YEAR:${
            appState.filters.lastYear
          }${idFilter}${msaFilter}${countyFilter}&agg_limit=100`,
        )
          .then((response) => {
            if (isMounted) {
              const data = response.data;
              for (const dataElem of data) {
                const count = dataElem["sum_DEPSUMBR"];
                const state = dataElem["STALPBR"];
                sumDepositsDataByState[state] = count;
              }
              const values = Object.values(sumDepositsDataByState);
              const sum = values.reduce((accumulator, value) => {
                return accumulator + value;
              }, 0);
              setTotalSummaryOfDeposits(sum);
              if (stateElement && stateElement.current) {
                stateElement.current.innerText = "All States and Territories";
              }
              if (
                summaryOfDepositsElement &&
                summaryOfDepositsElement.current
              ) {
                summaryOfDepositsElement.current.innerText = `$${sum.toLocaleString()}`;
              }
              setSummaryOfDepositsByState(sumDepositsDataByState);
              const depositsSorted = Object.values(sumDepositsDataByState).sort(
                (a, b) => a - b,
              );
              const highest = depositsSorted[depositsSorted.length - 1] * 1000;
              const lowest =
                (depositsSorted.find((val) => val > 0) || 0) * 1000;
              setStateMidMax({
                low: lowest,
                mid: (lowest + highest) / 2,
                max: highest,
              });
              const respMapData = data.map((state: KeyValue) => {
                return { id: state.STALPBR, value: 0 };
              });
              for (const elem of respMapData) {
                const statesAbbr = elem["id"];
                if (sumDepositsDataByState[statesAbbr]) {
                  elem["value"] = sumDepositsDataByState[statesAbbr] * 1000;
                }
              }
              setMapData(respMapData);
              setPreviousYear(appState.filters.lastYear);
            }
          })
          .catch((error: Error) => {
            console.error(error);
          })
          .finally(() => (isMounted = false));
      })();
    }
  }, [
    summaryOfDepositsByState,
    appState.filters.lastYear,
    totalSummaryOfDeposits,
    previousYear,
    locationsData,
    idFilter,
    msaFilter,
    countyFilter,
    prevIdFilter,
  ]);

  React.useEffect(() => {
    //get total count of institutions
    if (
      (totalInstitutions === 0 || idFilter !== prevIdFilter) &&
      appState.filters.lastYear
    ) {
      setPrevIdFilter(idFilter);
      let isMounted = true;
      let institutions = 0;
      (async () => {
        await fetchData(
          `${ApiBaseUrl()}/sod?&agg_by=CERT&filters=YEAR:${
            appState.filters.lastYear
          } AND BKMO:1${idFilter}&limit=1`,
        )
          .then((response) => {
            if (isMounted) {
              institutions = response.totals.count;
              setTotalInstitutions(institutions);
              if (institutionsElement && institutionsElement.current) {
                institutionsElement.current.innerText =
                  institutions.toLocaleString();
              }
            }
          })
          .catch((error: Error) => {
            console.error(error);
          })
          .finally(() => (isMounted = false));
      })();
    }
  }, [
    totalInstitutions,
    appState.filters.lastYear,
    locationsOnly,
    idFilter,
    prevIdFilter,
  ]);

  React.useEffect(() => {
    //get total count of branch offices
    if (
      (totalBranchOffices === 0 || idFilter !== prevIdFilter) &&
      appState.filters.lastYear
    ) {
      let isMounted = true;
      let branchOffices = 0;
      setPrevIdFilter(idFilter);
      (async () => {
        await fetchData(
          `${ApiBaseUrl()}/sod?&agg_by=UNINUMBR&filters=YEAR:${
            appState.filters.lastYear
          }${idFilter}&agg_limit=1`,
        )
          .then((response) => {
            if (isMounted) {
              branchOffices = response.totals.count;
              setTotalBranchOffices(branchOffices);
              if (branchOfficesElement && branchOfficesElement.current) {
                branchOfficesElement.current.innerText =
                  branchOffices.toLocaleString();
                setDisplayBranchOffices(branchOffices.toLocaleString());
              }
            }
          })
          .catch((error: Error) => {
            console.error(error);
          })
          .finally(() => (isMounted = false));
      })();
    }
  }, [
    totalBranchOffices,
    appState.filters.lastYear,
    locationsOnly,
    idFilter,
    prevIdFilter,
  ]);

  React.useEffect(() => {
    //get count of institutions and branch offices by state
    if (
      (Object.keys(countOfInstitutionsByState).length === 0 ||
        Object.keys(countOfBranchOfficesByState).length === 0 ||
        prevIdFilter !== idFilter) &&
      appState.filters.lastYear
    ) {
      let isMounted = true;
      setPrevIdFilter(idFilter);
      const countOfInstitutionsByStateObj: KeyNumberValue = {};
      const countOfBranchOfficesByStateObj: KeyNumberValue = {};
      (async () => {
        await fetchData(
          `${ApiBaseUrl()}/sod?&agg_by=STALPBR&filters=YEAR:${
            appState.filters.lastYear
          }${idFilter}&get_unique=CERT&agg_limit=100`,
        )
          .then((response) => {
            if (isMounted) {
              const data = response.data;
              for (const dataElem of data) {
                const countInstByState = dataElem["unique_count"];
                const countBranchesByState = dataElem["count"];
                const state = dataElem["STALPBR"];
                countOfInstitutionsByStateObj[state] = countInstByState;
                countOfBranchOfficesByStateObj[state] = countBranchesByState;
              }
              setCountOfInstitutionsByState(countOfInstitutionsByStateObj);
              setCountOfBranchOfficesByState(countOfBranchOfficesByStateObj);
            }
          })
          .catch((error: Error) => {
            console.error(error);
          })
          .finally(() => (isMounted = false));
      })();
    }
  }, [
    appState.filters.lastYear,
    countOfInstitutionsByState,
    countOfBranchOfficesByState,
    idFilter,
    prevIdFilter,
  ]);

  React.useEffect(() => {
    return () => {
      // Clean up the chart instance when the component unmounts
      if (FusionCharts(chartId)) {
        FusionCharts(chartId).dispose();
      }
    };
  }, [chartId]);

  const colorRangeUSA = {
    minvalue: stateMidMax.low,
    startlabel: "Low",
    endlabel: "High",
    code: "#FFFFA2",
    gradient: "1",
    color: [
      {
        maxvalue: stateMidMax.mid,
        code: "#ED4630",
        displayValue: "Middle",
      },
      {
        maxvalue: stateMidMax.max,
        code: "#B2D1FD",
        displayValue: "High",
      },
    ],
  };

  const colorRangeStates = {
    minvalue: countyMidMax.low,
    startlabel: "Low",
    endlabel: "High",
    code: "#FFFFA2",
    gradient: "1",
    color: [
      {
        maxvalue: countyMidMax.mid,
        code: "#ED4630",
        displayValue: "Middle",
      },
      {
        maxvalue: countyMidMax.max,
        code: "#B2D1FD",
        displayValue: "High",
      },
    ],
  };

  const mapChartProps = {
    type: mapType,
    width: "750",
    height: "550",
    dataFormat: "JSON",
    dataSource: {
      chart: {
        animation: "0",
        caption:
          isCountyView && !dontShowCountyData
            ? "Rollover a county for more information"
            : isCountyView && dontShowCountyData
              ? ""
              : "Rollover / click a state for more information",
        entityfillhovercolor: "#EEEEEE",
        showlabels: selectedStateAbbr === "TX" ? "0" : "1",
        borderthickness: "0.4",
        theme: "fusion",
        showLegend: dontShowCountyData ? "0" : "1",
        basefontcolor: "#013a5d",
        entitytooltext: selectedStateAbbr === "GU" ? "Guam" : "<b>$lname</b>",
        numberPrefix: locationsOnly ? "" : "$",
        numberScaleValue: "1000,1000,1000",
        numberScaleUnit: "K,M,B",
      },

      colorrange: mapType !== "maps/usa" ? colorRangeStates : colorRangeUSA,

      data: isCountyView ? countyMapData : mapData,
    },
    events: isCountyView
      ? {
          entityRollover: (event: KeyValue, data: KeyValue) =>
            handleCountyMouseOver(data.label, data.id),
          entityRollout: () => handleCountyMouseOut(),
          entityClick: (event: KeyValue, data: KeyValue) => {
            if (dontShowCountyData || modalHeatMap) return;
            const countyName = countyNameByCodeLookup[data.id] ?? data.label;
            updateFilter(
              "county",
              selectedStateAbbr === "GU" ? "Guam" : countyName,
            );
            setMode("table");
          },
          legendRangeUpdated: (eventObj: KeyValue) =>
            handleRangeUpdated(eventObj),
        }
      : {
          entityRollover: (event: KeyValue, data: KeyValue) =>
            handleMouseOver(
              data.label,
              data.shortLabel,
              stateElement,
              summaryOfDepositsElement,
              summaryOfDepositsByState,
              institutionsElement,
              countOfInstitutionsByState,
              branchOfficesElement,
              countOfBranchOfficesByState,
            ),
          entityRollout: () =>
            handleMouseOut(
              stateElement,
              summaryOfDepositsElement,
              totalSummaryOfDeposits,
              institutionsElement,
              totalInstitutions,
              branchOfficesElement,
              totalBranchOffices,
            ),
          entityClick: (event: KeyValue, data: KeyValue) => {
            const abbr = (data.shortLabel || "").toUpperCase();
            if (
              !abbr ||
              !getMapType(abbr, appState.filters.lastYear) ||
              appState.filters?.msa
            )
              return;
            setChartId(`usa-map-${Date.now()}`);
            setSelectedState(data.label);
            setSelectedStateAbbr(abbr);
            setMapType(getMapType(abbr, appState.filters.lastYear));
          },

          legendRangeUpdated: (eventObj: KeyValue) =>
            handleRangeUpdated(eventObj),
        },
  };

  React.useEffect(() => {
    if (!selectedStateAbbr) return;
    const newMapType = getMapType(selectedStateAbbr, appState.filters.lastYear);
    if (newMapType !== mapType) {
      setChartId(`usa-map-${Date.now()}`);
      setMapType(newMapType);
    }
  }, [selectedStateAbbr, appState.filters.lastYear, mapType]);

  React.useEffect(() => {
    updateFilter("stalpbr", selectedStateAbbr || "");
  }, [selectedStateAbbr, updateFilter]);

  React.useEffect(() => {
    if (!isCountyView) {
      setMapType("maps/usa");
      setCountyMapData([]);
    }
  }, [isCountyView]);

  const showStatesAndTerritories = (minValue: number, maxValue: number) => {
    return (
      <>
        {usStatesAndTerritories.map((territory: KeyValue, index: number) => {
          return (
            <div
              key={index}
              onMouseOver={() => {
                handleMouseOver(
                  territory.altLabel ? territory.altLabel : territory.label,
                  territory.abbr,
                  stateElement,
                  summaryOfDepositsElement,
                  summaryOfDepositsByState,
                  institutionsElement,
                  countOfInstitutionsByState,
                  branchOfficesElement,
                  countOfBranchOfficesByState,
                );
              }}
              onClick={() => {
                setChartId(`usa-map-${Date.now()}`);
                setSelectedState(territory.label);
                setSelectedStateAbbr(territory.abbr);
                setMapType(
                  getMapType(territory.abbr, appState.filters.lastYear),
                );
              }}
              onMouseOut={() =>
                handleMouseOut(
                  stateElement,
                  summaryOfDepositsElement,
                  totalSummaryOfDeposits,
                  institutionsElement,
                  totalInstitutions,
                  branchOfficesElement,
                  totalBranchOffices,
                )
              }
            >
              <Grid container wrap="nowrap">
                <Grid>
                  <HeatBoxIcon
                    amount={
                      locationsOnly
                        ? countOfBranchOfficesByState[territory.abbr]
                        : summaryOfDepositsByState[territory.abbr]
                    }
                    rangeMinValue={minValue}
                    rangeMaxValue={maxValue}
                  />
                </Grid>
                <Grid className={classes.territory}>
                  <Typography color="primary.main" variant="body2">
                    {territory.label}
                    {territory.label === "Northern Mariana Islands" ? "**" : ""}
                  </Typography>
                </Grid>
              </Grid>
            </div>
          );
        })}
      </>
    );
  };

  const cardContent = locationsOnly ? (
    <CardContent>
      <Grid container spacing={1}>
        <Grid size={12}>
          <Grid ref={branchOfficesElement}></Grid>
        </Grid>
        <Grid size={12}>
          <Grid>
            <Typography color="primary.main" variant="body1">
              Branch Offices
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </CardContent>
  ) : (
    <CardContent>
      <Grid container spacing={1}>
        <Grid size={12}>
          <Grid ref={summaryOfDepositsElement}></Grid>
        </Grid>
        <Grid size={12}>
          <Typography color="primary.main" variant="body1">
            Total Deposits (Thousands USD)
          </Typography>
        </Grid>
        <Grid size={6}>
          <Grid ref={institutionsElement}></Grid>
        </Grid>
        <Grid size={6}>
          <Grid ref={branchOfficesElement}></Grid>
        </Grid>
        <Grid size={6}>
          <Typography color="primary.main" variant="body1">
            Institutions
          </Typography>
        </Grid>
        <Grid size={6}>
          <Typography color="primary.main" variant="body1">
            Branch Offices
          </Typography>
        </Grid>
      </Grid>
    </CardContent>
  );

  React.useEffect(() => {
    const stalpbr = (appState.filters.stalpbr || "").trim();

    if (!stalpbr) {
      setChartId(`usa-map-${Date.now()}`);
      setMode("map");
      setSelectedStateAbbr(null);
      setSelectedState(null);
      setMapType("maps/usa");
      setLegendRangeMinValue(0);
      setLegendRangeMaxValue(3000000000000);
    }
  }, [appState.filters.stalpbr]);

  React.useEffect(() => {
    if (mode !== "map") return;

    if (isCountyView) {
      const abbr = selectedStateAbbr || "";
      if (stateElement?.current) {
        const stateName = selectedStatesAlpha.filter((c) => c.value === abbr)[0]
          ?.label;
        stateElement.current.innerText =
          stateName || selectedState || abbr || "State";
      }
      if (summaryOfDepositsElement?.current) {
        const dep = summaryOfDepositsByState?.[abbr] ?? 0;
        summaryOfDepositsElement.current.innerText = `$${dep.toLocaleString()}`;
      }
      if (institutionsElement?.current) {
        const inst = countOfInstitutionsByState?.[abbr] ?? 0;
        institutionsElement.current.innerText = inst.toLocaleString();
      }
      if (branchOfficesElement?.current) {
        const branches = countOfBranchOfficesByState?.[abbr] ?? 0;
        branchOfficesElement.current.innerText = branches.toLocaleString();
      }
    } else {
      if (stateElement?.current) {
        stateElement.current.innerText = "All States and Territories";
      }
      if (summaryOfDepositsElement?.current) {
        summaryOfDepositsElement.current.innerText = `$${totalSummaryOfDeposits.toLocaleString()}`;
      }
      if (institutionsElement?.current) {
        institutionsElement.current.innerText =
          totalInstitutions.toLocaleString();
      }
      if (branchOfficesElement?.current) {
        branchOfficesElement.current.innerText =
          totalBranchOffices.toLocaleString();
      }
    }
  }, [
    mode,
    countOfBranchOfficesByState,
    countOfInstitutionsByState,
    isCountyView,
    selectedState,
    selectedStateAbbr,
    summaryOfDepositsByState,
    totalBranchOffices,
    totalInstitutions,
    totalSummaryOfDeposits,
  ]);
  React.useEffect(() => {
    if (isCountyView && selectedStateAbbr) {
      const branches = countOfBranchOfficesByState?.[selectedStateAbbr] ?? 0;
      setDisplayBranchOffices(branches.toLocaleString());
    } else if (!isCountyView && totalBranchOffices > 0) {
      setDisplayBranchOffices(totalBranchOffices.toLocaleString());
    }
  }, [
    isCountyView,
    selectedStateAbbr,
    countOfBranchOfficesByState,
    totalBranchOffices,
  ]);
  React.useEffect(() => {
    setCountOfInstitutionsByState({});
    setCountOfBranchOfficesByState({});
    setSummaryOfDepositsByState({});
    setTotalInstitutions(0);
    setTotalBranchOffices(0);
    setTotalSummaryOfDeposits(0);
    setPreviousYear(1994);
  }, [appState.filters.lastYear]);
  const openCloseButton =
    openCloseHeader.ALL && Object.keys(openCloseHeader.ALL).length > 1 ? (
      <Button
        id={
          Object.values(openCloseHeader.ALL).every((val) => val)
            ? "closeAllStates"
            : "openAllStates"
        }
        sx={(theme) => ({
          "minWidth": 80,
          "margin": 0,
          "color": "#ffffff",
          "fontWeight": 600,
          "backgroundColor": "#426cac",
          "&:hover, &.Mui-focusVisible": {
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.secondary.main,
          },
        })}
        onClick={() => {
          setOpenClose("ALL");
        }}
      >
        {Object.values(openCloseHeader.ALL).every((val) => val)
          ? "Close All"
          : "Open All"}
      </Button>
    ) : (
      ""
    );
  const locationOnlyMetaData: KeyValue[] = [
    {
      title: isBHC
        ? "State / County / Bank Holding Company Name"
        : "State / County / Institution Name",
      apiField: "",
      styles: {
        textAlign: "left",
        width: isBHC ? 310 : 219,
        minWidth: isBHC ? 310 : 219,
      },
    },
    {
      title: openCloseButton,
      apiField: "",
      styles: { minWidth: 116, width: 116 },
    },
    { title: "Main Office City, State", apiField: "", styles: {} },
    {
      title: isBHC ? "Unique BHCs*" : "Unique Institutions*",
      apiField: "",
      styles: { minWidth: 52, width: 52 },
    },
    {
      title: "Matching Offices",
      apiField: "",
      styles: { width: 52, minWidth: 52 },
    },
    { title: isBHC ? "RSSDHCR" : "CERT", apiField: "", styles: {} },
    ...(!isBHC ? [{ title: "Class", apiField: "", styles: {} }] : []),
    {
      title: "Matching Deposits (Thousands USD)",
      apiField: "",
      styles: { textAlign: "right", width: 140, minWidth: 140 },
    },
  ];
  const locationOnlyTableHeaders: TableHeader[][] = [
    locationOnlyMetaData.map((element) => ({
      title: element.title,
      styles: element.styles,
      colSpan: 1,
      apiField: element.apiField,
    })),
  ];

  // temporarily blocks mouse effects while the map renders
  const [blockHover, setBlockHover] = React.useState(false);
  React.useEffect(() => {
    if (isCountyView) {
      setBlockHover(true);
      const timer = setTimeout(() => setBlockHover(false), 250);
      return () => clearTimeout(timer);
    }
  }, [isCountyView, selectedStateAbbr]);

  const hidePills = [
    "charterClass",
    "assetSize",
    "top50CommercialBanks",
    "top50BHC",
    "stateAndTerritories",
    "nationalTimeSeries",
    "metroStatisticalArea",
    "stateCharterClass",
    "stateCounty",
  ].includes(reportType);
  const addDivider = reportType === "top50BHC";
  return (
    <Root
      $isCountyView={isCountyView}
      dontShowCountyData={dontShowCountyData}
      $modalHeatMap={modalHeatMap}
      providedAppState={providedAppState}
    >
      {!modalHeatMap && (
        <Typography color="primary.main" variant="h2" align="left">
          Concentration of Deposits{" "}
          {isCountyView &&
            `- ${selectedState}${selectedState === "Northern Mariana Islands" ? "**" : ""}`}
        </Typography>
      )}
      {addDivider && <br />}
      <Divider />
      {!hidePills && searchPills}
      {hidePills && <br />}
      {isCountyView && !providedAppState && (
        <Box sx={{ mb: mode === "table" ? 2 : 0.125 }}>
          <ResultsViewToggle
            mode={mode}
            onModeChange={(mode) => setMode(mode)}
            options={[
              { label: "table", icon: <TableChartIcon /> },
              { label: "map", icon: <PlaceOutlinedIcon /> },
            ]}
            onBackToNational={() => updateFilter("stalpbr", "")}
            backToNational={isCountyView && mode === "map"}
          />
        </Box>
      )}
      <Typography color="primary.main" variant="h2" align="center">
        <Grid container spacing={2}>
          <Grid
            size={{
              lg: mode === "map" ? 9 : 12,
              md: 12,
            }}
          >
            <Box
              sx={{
                display: mode === "map" ? "block" : "none",
              }}
            >
              {dontShowCountyData && (
                <>
                  <Typography variant="h4" mt={1.5}>
                    County-level deposits are not applicable to some territory
                    maps.
                  </Typography>
                  <Typography variant="h4" mt={-1.5}>
                    See table view for branch office details
                  </Typography>
                </>
              )}
              {
                // @ts-ignore
                <ReactFC
                  id={chartId}
                  key={`${chartId}-${mapType}-${selectedStateAbbr}`}
                  {...mapChartProps}
                />
              }
              {blockHover && (
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    zIndex: 10,
                    cursor: "default",
                    background: "transparent",
                  }}
                />
              )}
            </Box>

            <Box sx={{ display: mode === "table" ? "block" : "none" }}>
              <MultiHeaderTable
                useStickyHeader
                tableBody={
                  <SODStateList
                    appState={{
                      ...appState,
                      filters: {
                        ...appState.filters,
                        stateNames: [selectedStateAbbr],
                      },
                      ui: {
                        ...appState.ui,
                        location: "marketSelect",
                        marketSelection: [
                          {
                            certUninums: {},
                            cities: ["All"],
                            counties: ["All"],
                            zips: ["All"],
                          },
                        ],
                      },

                      sort: {
                        ...appState.filters,
                        sortField: "STNAME",
                        sortOrder: "ASC",
                      },
                    }}
                    openClose={openClose}
                    setOpenClose={setOpenClose}
                    openCloseAllDisplay={openCloseHeader}
                    setOpenCloseAllDisplay={setOpenCloseHeader}
                    locationOnlySearch
                  />
                }
                tableHeaders={locationOnlyTableHeaders}
              />
            </Box>
            {appState.filters?.stalpbr === "MP" && footerMP}
          </Grid>
          {mode === "map" && (
            <Grid
              size={{
                lg: 3,
                md: 12,
              }}
            >
              <Paper elevation={3} id="map-data-info">
                <Card className={classes.cardDisplay}>
                  <CardHeader
                    id="USAMap-summaryDepositsTextBox"
                    ref={stateElement}
                    sx={{
                      position: "relative",
                      color: "white",
                      background: (theme) => theme.palette.primary.main,
                      fontSize: "1.25rem",
                      padding: ".5rem",
                    }}
                  ></CardHeader>
                  {cardContent}
                </Card>
              </Paper>
              <br />
              {!isCountyView && (
                <>
                  {" "}
                  <Grid>
                    <Typography
                      color="primary.main"
                      className={classes.statesHeading}
                    >
                      States & Territories not depicted
                    </Typography>
                  </Grid>
                  {showStatesAndTerritories(
                    legendRangeMinValue,
                    legendRangeMaxValue,
                  )}
                  <Typography className={classes.footer}>
                    <br />
                    **AKA Commonwealth of the Northern Mariana Islands
                  </Typography>
                </>
              )}
            </Grid>
          )}
        </Grid>
      </Typography>
    </Root>
  );
}
